import { customEvent } from "goi_common";
import { GOI_PHONE, GOI_PHONE_HREF } from "@/constants/contact";
import { PhoneIcon } from "@/components/PhoneIcon";
import { useParlorInquiryModal } from "@/hooks/useParlorInquiryModal";

interface ParlorSidebarProps {
  companyName: string;
  parlorId: string;
  expectedChargeSum?: { [type: string]: number };
}

export const ParlorSidebar = ({
  companyName,
  parlorId,
  expectedChargeSum,
}: ParlorSidebarProps) => {
  const { openParlorInquiryModal } = useParlorInquiryModal("prlr_fam_main");
  const minCharge = expectedChargeSum?.["무빈소"];
  const maxCharge = expectedChargeSum?.["일반장"];
  const hasRange = minCharge || maxCharge;

  return (
    <aside className="pd-sidebar" aria-label="상담 및 견적 안내">
      <div className="pd-sidebar-card pd-sidebar-card--accent">
        <div className="pd-sidebar-card__head">
          <h3>무료 장례 견적</h3>
          <span className="pd-pill">즉시 안내</span>
        </div>
        <p className="pd-sidebar-note">
          {companyName} 시설 사용료, 인력·차량·용품 비용까지 항목 단위로
          투명하게 안내해 드립니다.
        </p>

        {hasRange && (
          <div style={{ marginBottom: 14 }}>
            <div className="pd-sidebar-stat">
              <span className="pd-sidebar-stat__lbl">예상 비용</span>
              <span className="pd-sidebar-stat__val">
                {minCharge ? (
                  <>
                    <em>{minCharge.toLocaleString()}</em>원
                  </>
                ) : (
                  "–"
                )}
                {" ~ "}
                {maxCharge ? (
                  <>
                    <em>{maxCharge.toLocaleString()}</em>원
                  </>
                ) : (
                  "–"
                )}
              </span>
            </div>
            <div style={{ fontSize: 11, color: "var(--fg-3)", marginTop: 4 }}>
              최소(무빈소) ~ 최대(일반장) 기준
            </div>
            <div className="pd-sidebar-disclaimer">
              *고이장례연구소 자체 추산 예상 비용으로, 실제 비용은 조문객
              수·용품 선택에 따라 달라집니다.
            </div>
          </div>
        )}

        <a
          className="pd-sidebar-cta"
          href={GOI_PHONE_HREF}
          onClick={(event) => {
            event.preventDefault();
            customEvent({
              newGtm: {
                path: "prlr_fam_main",
                trigger_and_target: "footer_goi_call",
              },
            });
            void openParlorInquiryModal();
          }}
        >
          <PhoneIcon size={15} />
          {GOI_PHONE} 무료 장례 상담
        </a>
        <a
          className="pd-sidebar-cta pd-sidebar-cta--ghost"
          href={`${process.env.NEXT_PUBLIC_PLATFORM_WEB_URL}/match/parlor-requests/${parlorId}/?utm_campaign=parlor`}
          onClick={() =>
            customEvent({
              newGtm: {
                path: "prlr_fam_main",
                trigger_and_target: "footer-uv_mtch_rqst_prlr",
              },
            })
          }
        >
          견적 비교하기
        </a>
      </div>

      <div className="pd-sidebar-card">
        <div className="pd-sidebar-card__head">
          <h3>고이 상담 현황</h3>
        </div>
        <div className="pd-sidebar-stat">
          <span className="pd-sidebar-stat__lbl">장례·상조 상담</span>
          <span className="pd-sidebar-stat__val">
            <em>22,000</em>명+
          </span>
        </div>
        <div className="pd-sidebar-stat">
          <span className="pd-sidebar-stat__lbl">후기 평균 점수</span>
          <span className="pd-sidebar-stat__val">
            <em>4.9</em>점 ★
          </span>
        </div>
        <div style={{ fontSize: 11, color: "var(--fg-3)", marginTop: 8 }}>
          *26년도 최근 3개월 기준 · 고이장례연구소 이용 후기입니다.
        </div>
      </div>
    </aside>
  );
};
